import './Login.scss';
import SignupStepper from './SignupStepper';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { IoIosMail } from "react-icons/io";
import kakaologo from "../../images/login/kakao.png"
import naverlogo from "../../images/login/naver.png"
import { useAtomValue } from "jotai";
import { kaKaoLoginDataAtom, naverLoginDataAtom } from "../../AtomStore";
import { getSignupUserType, USER_TYPE_ONBOARDING_PATH } from "./userTypeUtils";

export default function Logister() {
  const navigate = useNavigate();
  const kakaoLoginData = useAtomValue(kaKaoLoginDataAtom);
  const naverLoginData = useAtomValue(naverLoginDataAtom);

  useEffect(() => {
    if (!getSignupUserType()) {
      navigate(USER_TYPE_ONBOARDING_PATH, { replace: true, state: { signupFlow: true } });
    }
  }, [navigate]);

  const kakaoToken = `https://kauth.kakao.com/oauth/authorize?response_type=code&client_id=${kakaoLoginData.APIKEY}&redirect_uri=${kakaoLoginData.REDIRECT_URI_Auth}`;
  const naverToken = `https://nid.naver.com/oauth2.0/authorize?response_type=code&client_id=${naverLoginData.CLIENTID}&redirect_uri=${naverLoginData.REDIRECT_URI_Auth}&state=sdfsdfsdf`;

  return (
    <div className="lp">
      <main className="lp__page-wrap">
            <SignupStepper activeStep={2} />

            <div className="lp__auth-card">
              <div className="lp__auth-title-row">
                <div>
                  <h2 className="lp__auth-title">회원가입</h2>
                  <p className="lp__auth-subtitle">다음 방법으로 간편하게 시작하세요.</p>
                </div>
                <span className="lp__auth-link" onClick={() => navigate('/login')}>
                  이미 계정이 있나요?
                </span>
              </div>

              <div className="lp__social-row lp__social-row--three">
                <div
                  className="lp__social-box lp__social-box--kakao"
                  onClick={() => { window.location.href = kakaoToken; }}
                >
                  <div className="lp__social-icon lp__social-icon--kakao">
                    <img src={kakaologo} alt="카카오" />
                  </div>
                  <strong>카카오</strong>
                  <span>간편 가입</span>
                </div>
                <div
                  className="lp__social-box lp__social-box--naver"
                  onClick={() => { window.location.href = naverToken; }}
                >
                  <div className="lp__social-icon lp__social-icon--naver">
                    <img src={naverlogo} alt="네이버" />
                  </div>
                  <strong>네이버</strong>
                  <span>간편 가입</span>
                </div>
                <div
                  className="lp__social-box"
                  onClick={() => navigate('/login/logisterDetail', { state: { signupFlow: true, sort: 'email' } })}
                >
                  <div className="lp__social-icon lp__social-icon--email">
                    <IoIosMail size={16} />
                  </div>
                  <strong>이메일</strong>
                  <span>직접 가입</span>
                </div>
              </div>

              <div className="lp__divider">또는</div>

              <div style={{ textAlign: 'center' }}>
                <span className="lp__auth-link" onClick={() => navigate('/login')}>
                  이미 계정이 있으신가요? 로그인하기
                </span>
              </div>
            </div>
      </main>
    </div>
  );
}
